import {
  ADD_REGULATORY_REPORTING_TYPE,
  ADD_REGULATORY_REPORTING_TYPE_COMPLETED,
  ADD_REGULATORY_REPORTING_TYPE_FAILED,
  GET_REGULATORY_REPORTING_TYPES,
  GET_REGULATORY_REPORTING_TYPES_COMPLETED,
  GET_REGULATORY_REPORTING_TYPES_FAILED
} from "./actions";

const defaultState = {
  error: null,
  regulatoryReportingTypesLoading: false,
  regulatoryReportingTypes: [],
  addingRegulatoryReportingType: false,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case GET_REGULATORY_REPORTING_TYPES: {
      return {...state, regulatoryReportingTypes: [], regulatoryReportingTypesLoading: true};
    }
    case GET_REGULATORY_REPORTING_TYPES_COMPLETED: {
      const regulatoryReportingTypes = action.payload.data;
      return {...state, regulatoryReportingTypes, regulatoryReportingTypesLoading: false};
    }
    case GET_REGULATORY_REPORTING_TYPES_FAILED: {
      const error = action.payload;
      return {...state, regulatoryReportingTypesLoading: false, error};
    }
    case ADD_REGULATORY_REPORTING_TYPE: {
      return {...state, addingRegulatoryReportingType: true};
    }
    case ADD_REGULATORY_REPORTING_TYPE_COMPLETED: {
      return {...state, addingRegulatoryReportingType: false};
    }
    case ADD_REGULATORY_REPORTING_TYPE_FAILED: {
      const error = action.payload;
      return {...state, addingRegulatoryReportingType: false, error};
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/RegulatoryReporting/reducer.js